module.exports = __webpack_public_path__ + "img/zrx.4f863f26.svg";